module.exports = __webpack_public_path__ + "static/img/icon-completed.393067e7.svg";